import {useState} from 'react';
import {Link} from "react-router-dom";
import Logo from '../../components/logo/Logo';
import FooterLinkItem from '../../components/Footer/FooterLinkItem.jsx';
import PrivacyModal from "../../components/Footer/PrivacyModal";
import {getTranslated} from "../../utils/languageUtil";
const Footer = () => {
    const [show, setShow] = useState(false);//modal
    const FooterData = getTranslated('Footer');
    const togglePrivacyModal = (e) => {
        e.preventDefault();
        setShow(!show);
    }
    return (
        <div className="footer-section section footer-bg-color">
            <div className="container">
                <div className="row mb-lg-14 mb-md-10 mb-6">

                    <div className="col-xl-2 col-lg-2 col-md-4 col-sm-6 col-12 mb-6">
                        <div className="footer-widget">
                            <div className="footer-logo">
                                <Logo 
                                    image={`${process.env.PUBLIC_URL}/images/logo/logo.png`}
                                />
                            </div>
                            <div className="footer-widget-content">
                                <div className="content">
                                    <p><Link to={process.env.PUBLIC_URL + "/#"} style={{cursor:"default"}} onClick={(e)=>e.preventDefault()} >+385 98 876 563</Link></p>
                                    <p><Link to={process.env.PUBLIC_URL + "/#"} style={{cursor:"default"}} onClick={(e)=>e.preventDefault()}>info@quantum-solutions.hr</Link></p>
                                </div>
                                <div className="footer-social-inline">
                                    <a href="https://www.linkedin.com/company/quantum-solutions-d-o-o" target="_blank" rel="noopener noreferrer"><i className="fab fa-linkedin"></i></a>
                                </div>
                            </div>
                        </div>
                    </div>

                    {FooterData['items'] && FooterData['items'].map((single, key) => {
                            return(
                                <div key={key} className="col-xl-2 col-lg-2 col-md-4 col-sm-6 col-6 mb-6">
                                    <FooterLinkItem data={single} key={key} />
                                </div>
                            ); 
                    })}
                    <div className="col-xl-2 col-lg-2 col-md-4 col-sm-6 col-6 mb-6">
                        <div className="footer-widget">
                            <h4 className="footer-widget-title">{FooterData['about']}</h4>
                            <div className="footer-widget-content">
                                <ul>
                                    <li>
                                        <Link to={process.env.PUBLIC_URL + "/#"} onClick={togglePrivacyModal}>{FooterData['privacy']}</Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <PrivacyModal show={show} setShow={setShow}/>

                </div>

                <div className="row">
                    <div className="col">
                        <p className="copyright">&copy; 2022  <a className="primary" href="https://quantum-solutions.hr/"><strong>Quantum Solutions</strong></a> All rights reserved</p>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default Footer
